"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));
var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
var classnames_1 = __importDefault(require("classnames"));
var InfoCard = function (props) {
  var _a;
  var bem = (0, hook_use_bem_classes_1.default)('rwc-info-card');
  var size = (_a = props.size) !== null && _a !== void 0 ? _a : 'sm';
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: (0, classnames_1.default)(bem(), bem('', size))
  }, {
    children: [props.title && (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
      tag: "h2",
      className: (0, classnames_1.default)(bem('title'), bem('title', size))
    }, {
      children: props.title
    })), props.description && (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
      tag: "div",
      className: (0, classnames_1.default)(bem('description'), bem('description', size))
    }, {
      children: props.description
    })), props.link && (0, jsx_runtime_1.jsxs)("a", __assign({
      className: bem('link'),
      href: props.link.linkUrl,
      target: props.link.linkTarget
    }, {
      children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
        tag: "span"
      }, {
        children: props.link.linkText
      })), props.link.external && (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
        type: "fas-external-link",
        style: {
          height: 14,
          width: 14
        }
      })]
    }))]
  }));
};
exports.default = InfoCard;